<template>
    <header class="header" v-if="!isMobile">
        <div class="navbar-fixed">
            <nav class="header-blank-desktop">
                <div class="container">
                    <a
                        @click="pushRoute({ url: 'LandingPage', solo: false })"
                        class="brand-logo-blank-desktop"
                    >
                        <img src="@/assets/images/engelink_logo.svg" alt="Engelink" />
                    </a>
                    <ul class="blank-menu-top-desktop">
                        <li v-if="showLogout" @click="logoutWithRedirect">
                            <span class="blank-title-menu">Sair</span>
                        </li>
                        <li v-else>
                            <span class="blank-title-menu"></span>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    </header>
    <div v-else :class="[{ 'opacity-background': show }]">
        <header>
            <div class="navbar-fixed">
                <nav class="header-blank-mobile">
                    <div
                        @click="
    show = !show;
$emit('show', show);
                        "
                        :class="['nav-icon', { open: show }]"
                    >
                        <div></div>
                    </div>
                    <a
                        @click="pushRoute({ url: 'LandingPage', solo: false })"
                        class="brand-logo-blank-mobile"
                    >
                        <img
                            src="@/assets/images/engelink_logo.svg"
                            class="center-element"
                            alt="Engelink"
                        />
                    </a>
                </nav>
            </div>
            <div :class="['side-bar-blank-mobile', { show: show }]">
                <ul>
                    <li v-if="showLogout">
                        <a @click="logoutWithRedirect">
                            <span class="title-mobile">Sair</span>
                        </a>
                    </li>
                </ul>
            </div>
        </header>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
    name: 'HeaderBlank',
    props: {
        // showLogout: { type: Boolean, default: true }
    },
    data: () => ({
        show: false,
        isMobile: ''
    }),
    methods: {
        ...mapActions('user', ['logout']),
        logoutWithRedirect () {
            this.logout();
            this.$router.push({ name: 'LandingPage' });
        },
        pushRoute (objectUrl) {
            if (objectUrl.solo) {
                window.open(objectUrl.url, '_blank');
            } else if (objectUrl.url && this.$route.name != objectUrl.url) {
                this.$router.push({ name: objectUrl.url });
            }
            this.show = false;
        }
    },
    computed: {
        showLogout () {
            return this.$route.name != 'Checkout' && this.$route.name != 'StructuredQuote';
        }
    },
    mounted () {
        const vue = this;
        window.addEventListener('resize', () => {
            vue.isMobile = window.innerWidth <= 920;
        });
        vue.isMobile = window.innerWidth <= 920;
    }
};
</script>

<style lang="scss">
.header {
    height: 54px;
}

.header-blank-desktop {
    background-color: #ffffff;
    height: 54px;
    line-height: 54px;
}

.header-blank-desktop .container {
    width: 90%;
    display: flex;
    justify-content: flex-start;
    justify-items: space-between;
    z-index: 999 !important;
}
.brand-logo-blank-desktop {
    align-items: center;
    display: flex;
    flex-grow: 1;
    justify-content: flex-start;
}
.blank-menu-top-desktop {
    display: flex;
    flex-grow: 1;
    justify-content: flex-end;
}
.blank-menu-top-desktop li {
    display: inline-block;
    position: relative;
    cursor: pointer;
    font-size: 14px;
    color: #707070;
}
.blank-menu-top-desktop li .blank-title-menu {
    padding-inline: 15px;
}
.blank-menu-top-desktop li:hover {
    transition: 0.3s;
    font-weight: bold;
}

li {
    list-style-type: none;
}
.header-blank-mobile {
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    z-index: 999 !important;
}
nav .brand-logo-blank-mobile {
    align-items: center;
    display: flex;
    flex-direction: column;
    font-size: 1.6rem;
    height: 54px;
    justify-content: center;
    width: 150px;
}
nav .brand-logo-blank-mobile img {
    max-height: 40px;
    max-width: 150px;
}
/* // Tracinho de cima */
.nav-icon:before {
    width: 35px;
}
/* // Tracinho do meio */
.nav-icon {
    /* // margin: 1em; */
    left: 0;
    position: fixed;
    width: 30px;
    margin-left: 25px;
    align-self: center;
}
/* // Tracinho de baixo */
.nav-icon:after {
    width: 25px;
}
.nav-icon:after,
.nav-icon:before,
.nav-icon div {
    background-color: #003f7e;
    border-radius: 3px;
    content: "";
    display: block;
    height: 4px;
    margin: 4px 0;
    transition: all 0.4s ease-in-out;
}
/* // largura quando o menu está aberto */
.nav-icon.open:after,
.nav-icon.open:before,
.nav-icon.open {
    width: 20px;
    margin: 8px 13px;
}
.nav-icon.open:before {
    transform: translateY(12px) rotate(135deg);
}

.nav-icon.open:after {
    transform: translateY(-12px) rotate(-135deg);
}

.nav-icon.open div {
    transform: scale(0);
}
.side-bar-blank-mobile {
    box-shadow: inset 0 0 2px black;
    text-align: justify;
    position: fixed;
    height: 100%;
    width: 0%;
    z-index: 9999 !important;
    background-color: #fff;
    color: #000;
    transition: 0.5s;
    overflow: hidden;
    box-shadow: black;
}
.side-bar-blank-mobile.show {
    box-shadow: inset 0px 3px 6px #00000029;
    width: 80%;
}
.side-bar-blank-mobile ul {
    /* // position: absolute; */
    top: 0;
    left: 0;
    width: 100%;
}
.side-bar-blank-mobile ul li {
    position: relative;
    width: 100%;
    list-style: none;
}
.side-bar-blank-mobile ul li a .title-mobile {
    position: relative;
    display: block;
    padding: 0 10px;
    text-align: start;
    white-space: nowrap;
}
.side-bar-blank-mobile ul li a {
    position: relative;
    display: block;
    width: 100%;
    /* // display: flex; */
    text-decoration: none;
    padding: 13px 16px 13px 16px;
    text-decoration: none;
    font-size: 16px;
    color: #707070;
}
.side-bar-blank-mobile.show {
    width: 80%;
}
/* efeito de opacidade do menu de fornecedor na versão mobile */
.opacity-background {
    position: fixed;
    z-index: 2;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.25);
    display: table;
    transition: 0.5s;
    overflow: hidden;
}
.btn-blank-mobile {
    display: flex;
    justify-content: flex-start;
    margin-top: 15px;
    margin-left: 25px;
}
.blank-btn-mobile {
    width: 90%;
}
.supplier-guest-mobile-title {
    color: #007bff;
}
</style>
